module.exports = __webpack_public_path__ + "img/5gtgs.290e8a41.png";